module.exports = __webpack_public_path__ + "static/media/kpi-planning.0810e22e.svg";